<div class="chip-input-wrapper">
  <mat-form-field class="full-page-width">
    <mat-label>Base Station Handsets</mat-label>
    <mat-chip-grid #chipList [formControl]="chipsControl">
      @for (value of displayValues; track value) {
        <mat-chip-row
          [selectable]="false"
          [removable]="true"
          (removed)="removeValue(value)"
          >
          {{ getChipDisplay(value) }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
      }
      <input
        autocomplete="off"
        #chipInput
        type="text"
        [formControl]="inputControl"
        [lcsSingleSelect]="groupSelect"
        name="extension-group-filter"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="add($event)"
        [openPanelOnFocus]="true"
        (input)="onInputChange($event)"
        (blur)="removeErrors()"
        placeholder="Search"
        />
      </mat-chip-grid>
    </mat-form-field>
    <div class="results-container">
      <ndt-basestation-chip-select
        class="ndt-extension-and-group-select"
        #groupSelect
        (optionSelected)="selected($event)"
        [extensions]="filteredExtensions"
        [extensionIdsToExclude]="[]"
      ></ndt-basestation-chip-select>
    </div>
  </div>
